import React, { useContext } from 'react'
import { Responsive } from 'responsive-react'
import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Utilities from 'Utilities'
import ActionButtons from './ActionButtons'
import WithholdingsListContext from './WithholdingsListContext'

const LargeScreen = () => {
  const { t } = useTranslation()
  const { withholdings, highlightId } = useContext(WithholdingsListContext)

  return (
    <Responsive displayIn={['Laptop']}>
      <Table striped bordered hover>
        <thead>
          <tr className="text-center">
            <th>{t('provider')}</th>
            <th>{t('correlative')}</th>
            <th>{t('date')}</th>
            <th>{t('txt_generated_date')}</th>
            <th>{t('impositive_period')}</th>
            <th>IVA</th>
            <th>ISLR</th>
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {withholdings.map(withholding => (
            <tr
              className={`text-center${highlightId && withholding.Id === highlightId ? ' table-info' : ''}`}
              key={withholding.Id}
              id={`withholding-row-${withholding.Id}`}
            >
              <td>{withholding.Provider.BusinessName}</td>
              <td>{withholding.Correlative}</td>
              <td>{Utilities.TransformDate(withholding.Date)}</td>
              <td>
                {withholding.DateGenerate === '2000-01-01T00:00:00'
                  ? t('txt_not_generated_yet')
                  : Utilities.TransformDateTime(withholding.DateGenerate)}
              </td>
              <td>{withholding.ImpositivePeriod}</td>
              <td>{withholding.TotalIvaRetained ? Utilities.FormatCurrency(withholding.TotalIvaRetained) : '-'}</td>
              <td>{withholding.TotalIslrRetained ? Utilities.FormatCurrency(withholding.TotalIslrRetained) : '-'}</td>
              <td className="text-center">
                <ActionButtons
                  idWithholding={withholding.Id}
                  correlative={withholding.Correlative}
                  providerEmail={withholding.Provider.Email}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Responsive>
  )
}

export default LargeScreen
